import _extends from "@babel/runtime/helpers/esm/extends";
import { slug, getCookie } from '@magalu/mixer-utils';
var formatLocation = function formatLocation(location) {
  if ((location == null ? void 0 : location.zipCodeCity) && (location == null ? void 0 : location.zipCodeState)) {
    return "cep:".concat(slug(location.zipCode), ":").concat(slug(location.zipCodeCity), ":").concat(slug(location.zipCodeState));
  }
  return null;
};
var getLoginStatus = function getLoginStatus(customerId) {
  return customerId ? 'logado' : 'nao-logado';
};
export var buildEvent = function buildEvent(_ref) {
  var args = _ref.args;
  return _extends({
    event: 'select_content',
    screenName: 'marcas'
  }, args);
};
export var allBrandsLetterFilterClick = function allBrandsLetterFilterClick() {
  var _value$letter;
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    value = _ref2.value;
  var letter = value == null ? void 0 : (_value$letter = value.letter) == null ? void 0 : _value$letter.toLowerCase();
  return buildEvent({
    args: {
      content_id: letter ? "inicial:".concat(letter) : undefined,
      content_type: 'marcas'
    }
  });
};
export var brandClick = function brandClick() {
  var _value$slug;
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    value = _ref3.value;
  var brand = value == null ? void 0 : (_value$slug = value.slug) == null ? void 0 : _value$slug.toLowerCase();
  return buildEvent({
    args: {
      content_id: brand ? "marca:".concat(brand) : undefined,
      content_type: 'marcas'
    }
  });
};
export var allBrandVirtualPageview = function allBrandVirtualPageview(_ref4) {
  var _structure$cookies2, _data$product, _data$product$categor, _data$product2, _data$product2$subcat;
  var data = _ref4.data,
    structure = _ref4.structure;
  var siteId = structure.id,
    _structure$cookies = structure.cookies,
    cookies = _structure$cookies === void 0 ? {} : _structure$cookies,
    device = structure.device;
  var cookiesLocation = cookies == null ? void 0 : cookies.location;
  var accountData = ((_structure$cookies2 = structure.cookies) == null ? void 0 : _structure$cookies2.accountData) || null;
  var customerId = (accountData == null ? void 0 : accountData.customer_id) || null;
  var clientId = (cookies == null ? void 0 : cookies.clientId) || null;
  var category = slug(data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$categor = _data$product.category) == null ? void 0 : _data$product$categor.id) || null;
  var subCategory = slug(data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$subcat = _data$product2.subcategory) == null ? void 0 : _data$product2$subcat.id) || null;
  var location = {
    zipCode: cookiesLocation == null ? void 0 : cookiesLocation.zipCode,
    zipCodeCity: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeCity,
    zipCodeState: cookiesLocation == null ? void 0 : cookiesLocation.zipCodeState
  };
  if (siteId === 'all-brands') {
    return {
      buybox: 1,
      cepPreenchido: location.zipCode ? 1 : 0,
      cidadeuf: formatLocation(location),
      clientId: clientId,
      device: device || null,
      event: 'virtualPageview',
      fbc: getCookie('_fbc'),
      fbp: getCookie('_fbp'),
      idUsuario: customerId || null,
      loginAtivo: getLoginStatus(customerId),
      mundos: 'magalu',
      pageCategory: "".concat(category || null, ":").concat(subCategory || null),
      pageType: 'marcas',
      screenName: 'marcas',
      usuarioClube: null
    };
  }
  return null;
};